<template>
  <div>
    <TopBar :page="topBarData" @menuItemClick="topMenuClicked"/>
    <v-container fluid>
      <v-row>
        <v-col cols="12"><ViewRelatedProductBanner /></v-col>
        <v-col cols="12" md="3"><ViewStatusData /></v-col>
        <v-col cols="12" md="2"><ViewLeadSource /></v-col>
        <v-col cols="12" md="5"><ViewCustomerDetails /></v-col>
        <v-col cols="12" md="2"><ViewBillingAccount /></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6"><ViewQuestions /></v-col>
        <v-col cols="12" md="3"><ViewPainPoints /></v-col>
        <v-col cols="12" md="3"><ViewStaticData /></v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3"><ViewSingleProduct /></v-col>
        <v-col cols="12" md="3"><ViewBundledProduct /></v-col>
        <v-col cols="12" md="3"><ViewDemoProduct /></v-col>
        <v-col cols="12" md="3"><ViewCurrentProvider /></v-col>
      </v-row>
    </v-container>
    <LeadAuditDialog :lead_id="leadId" :dialogOpen="auditOpen" @close-search="auditOpen=false" />
    <ViewQuoteDialog :lead_id="leadId" :dialogOpen="quoteOpen" @close-dialog="quoteOpen=false" />
    <CreateBillingAccountDialog />
    <SendDDMandate />
    <SendSms :dialogOpen="sendSmsOpen" @close-dialog="sendSmsOpen=false;" />
  </div>
</template>

<script>
  import TopBar from "../components/Layout/TopBar";
  import ViewStatusData from "../components/Leads/ViewStatusData";
  import ViewBillingAccount from "../components/Leads/ViewBillingAccount";
  import ViewLeadSource from "../components/Leads/ViewLeadSource";
  import ViewCustomerDetails from "../components/Leads/ViewCustomerDetails";
  import ViewQuestions from "../components/Leads/ViewQuestions";
  import ViewPainPoints from "../components/Leads/ViewPainPoints";
  import ViewStaticData from "../components/Leads/ViewStaticData";
  import ViewCurrentProvider from "../components/Leads/ViewCurrentProvider";
  import LeadAuditDialog from "../components/Leads/Dialogs/LeadAuditDialog";
  import ViewQuoteDialog from "../components/Leads/Dialogs/ViewQuoteDialog";
  import CreateBillingAccountDialog from "../components/Leads/Dialogs/CreateBillingAccountDialog";
  import SendDDMandate from "../components/Leads/Dialogs/SendDDMandate";
  import SendSms from "../components/Leads/Dialogs/SendSms";
  import ViewRelatedProductBanner from "../components/Leads/ViewRelatedProductBanner";
  import ViewSingleProduct from "../components/Leads/ViewSingleProduct";
  import ViewBundledProduct from "../components/Leads/ViewBundledProduct";
  import ViewDemoProduct from "../components/Leads/ViewDemoProduct";

  const OLD_CRM_LINK = process.env.VUE_APP_API_HOST || `https://ctst-testing.appspot.com/`;

  import { mapState,mapActions,mapMutations,mapGetters } from "vuex";

  export default {
    components: {SendDDMandate,TopBar,ViewCustomerDetails,ViewLeadSource,ViewBillingAccount,ViewPainPoints,ViewQuestions,ViewStaticData,ViewStatusData,LeadAuditDialog,ViewQuoteDialog,CreateBillingAccountDialog,SendSms,ViewRelatedProductBanner,ViewCurrentProvider,ViewSingleProduct,ViewBundledProduct,ViewDemoProduct},
    
    data() {
      return {
        leadId: this.$route.params.id,
        auditOpen: false,
        quoteOpen: false,
        linkMapping: {'web': 'sites','voip': 'voip','telco': 'phonelines'},
        sendSmsOpen: false,
      }
    },

    computed: {
      ...mapState('leads', ['currentLead','sendDDMandateLoading','currentLeadLoading']),
      ...mapState('productLinks', ['linkedProduct']),
      ...mapGetters('leads', ['getTopBarInfo']),
      ...mapGetters('productLinks', ['getLinkedProductId']),

      topBarData() {
        return {
          name: this.getTopBarInfo.business,
          type:'lead',
          menu:true,
          showSearch:true,
          breadcrumbs: [
            {text:'Daily Leads',disabled:false,href:'/daily/'},
            {text:this.getTopBarInfo.business,disabled:true,href:''},
          ]
        }
      },

      getAccountSearchQuery() {
        const KEYS = {
          phone_number: "phone",
          mobile_number: "mobile",
          email_address: "email",
        };
        
        let query = [];
        
        for(const key in KEYS) {
          if(this.currentLead.contact[key]){
            query.push(`${KEYS[key]}=${this.currentLead.contact[key]}`);
          }
        }

        return query.length ? query.join(" OR ") : null;
      },

      getProductSearchQuery() {
        return `status:("Trial" OR "Trial Expired") email:${ this.currentLead.contact.email_address } OR mobile:${ this.currentLead.contact.mobile_number }`;
      },
    },

    methods: {
      ...mapActions('leads', ['getLeadByID','getLeadProductByID','getLeadLinkedProductByID','getLeadTariffs','getLeadOptions']),
      ...mapActions('demos', ['fetchDemoById']),
      ...mapActions('leads/accountSearch', ['fetchAccountSearch']),
      ...mapMutations('leads',['SET_CREATE_BILLING_OPEN','setSendDDMandateOpen']),
      ...mapActions('productLinks', ['fetchLinkedProduct']),
      ...mapActions('accounts', ['fetchAccountBalance']),
      ...mapActions('productGeneral', ['searchProducts']),
      ...mapMutations('productGeneral', ['RESET_SEARCH_PRODUCTS']),

      async topMenuClicked(menuItem){
        switch(menuItem){
          case 'sendDirectDebitMandate':
            this.setSendDDMandateOpen(true);
            break;
          case 'createBilling':
            this.SET_CREATE_BILLING_OPEN(true);
            break;
          case 'sendSms':
            this.sendSmsOpen = true;
            break;
          case 'audit':
            this.auditOpen = true;
            break;
          case 'quote':
            this.quoteOpen = true;
            break;
          case 'viewOnOldCrm':
            window.open(`${OLD_CRM_LINK}${this.linkMapping[this.currentLead.kind.toLowerCase()]}/search?query=${this.$route.params.id}`);
            break;
        }
      },

      async loadLeadLinkedProductByID(leadID) {
        if(this.getLinkedProductId(leadID).lead) {
          await this.getLeadLinkedProductByID(this.getLinkedProductId(leadID).lead);
        }
      }
    },

    beforeDestroy() {
      this.RESET_SEARCH_PRODUCTS();
    },

    async mounted () {
      await this.getLeadByID({id:this.leadId});
      
      if(this.currentLead.kind === "VOIP") {
        this.searchProducts(this.getProductSearchQuery);
      }

      if(this.currentLead.voip_demo_id) {
        this.fetchDemoById({ id: this.currentLead.voip_demo_id });
      }

      if(this.getAccountSearchQuery && !this.currentLead.account_id) {
        this.fetchAccountSearch(this.getAccountSearchQuery);
      }

      if(this.currentLead.account_id) {
        this.fetchAccountBalance(this.currentLead.account_id);
      }
      
      await this.getLeadOptions();
      await this.getLeadTariffs();
      await this.getLeadProductByID({id:this.leadId});
      await this.fetchLinkedProduct(this.leadId);
      await this.loadLeadLinkedProductByID(this.leadId);

      this.topBarData.name = `${this.currentLead.id} - ${this.currentLead.business_name}`;
      this.topBarData.breadcrumbs[1].text = this.topBarData.name;
    },
  }
</script>

<style lang="scss" scoped></style>
